import '../components/tc-modal';
import IMask from 'imask';
const createModal = () => {
    const base64BlockUrl = btoa('contact form confirmation');
    fetch('/cmsblock/getblock/t/' + base64BlockUrl, {
        method: 'GET',
        cache: 'no-cache',
    })
        .then((response) => {
        if (response.ok === false) {
            throw new Error('Unknown failure');
        }
        return response.json();
    })
        .then((result) => {
        const modalTag = document.createElement('tc-modal');
        modalTag.innerHTML = result.html;
        document.body.appendChild(modalTag);
    })
        .catch((err) => {
        console.error(err);
    });
};
const removeErrorSignature = (input) => {
    input.classList.remove('error');
    if (input.parentNode) {
        const status = input.parentNode.querySelector('.status');
        if (status) {
            status.textContent = '';
        }
    }
};
const addFormFieldMask = (form) => {
    const zipCodeField = form.querySelector('input[name="P[postal_code]"]');
    if (!zipCodeField) {
        return;
    }
    const maskValue = zipCodeField.dataset.mask;
    if (!maskValue) {
        return;
    }
    const maskOptions = {
        mask: maskValue,
    };
    const masked = [];
    masked.push(IMask(zipCodeField, maskOptions));
    return masked;
};
const addShowFormListener = (formTrigger, form) => {
    if (formTrigger) {
        formTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            if (form) {
                form.classList.toggle('form-hidden');
                if (!form.classList.contains('form-hidden')) {
                    form.scrollIntoView({ behavior: 'smooth' });
                }
            }
        });
    }
};
const responseHandle = (response, form) => {
    if (response.success === true) {
        form.reset();
        form.querySelectorAll('.error').forEach((elem) => {
            elem.classList.remove('error');
        });
        form.querySelectorAll('.status').forEach((elem) => {
            elem.textContent = '';
        });
        const modal = document.querySelector('tc-modal');
        if (modal) {
            modal.open();
        }
    }
    if (response.errors) {
        for (const [key, value] of Object.entries(response.errors)) {
            const input = document.querySelector(`[name="${key}"]`);
            if (input) {
                input.addEventListener('input', () => {
                    removeErrorSignature(input);
                }, false);
                input.classList.add('error');
                if (!input.parentNode) {
                    continue;
                }
                const status = input.parentNode.querySelector('.status');
                if (!status) {
                    continue;
                }
                status.textContent = '' + value;
            }
        }
    }
};
const addSubmitFormListener = (form) => {
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (form.dataset.processing == '1') {
            return;
        }
        form.dataset.processing = '1';
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        const formData = new FormData(form);
        const data = new URLSearchParams();
        for (const pair of formData) {
            data.append(pair[0], typeof pair[1] === 'string' ? pair[1] : '');
        }
        fetch('/contactform/send', {
            method: 'POST',
            cache: 'no-cache',
            body: data,
        })
            .then((response) => {
            if (response.ok === false) {
                throw new Error('Unknown failure');
            }
            return response.json();
        })
            .then((result) => {
            responseHandle(result, form);
        })
            .catch((err) => {
            console.error(err);
        })
            .finally(() => {
            form.dataset.processing = '0';
        });
    });
};
export default () => {
    const formTrigger = document.querySelector('.js-open-contact-form');
    const form = document.querySelector('#contactByEmailForm');
    if (formTrigger && form) {
        const masked = addFormFieldMask(form);
        addShowFormListener(formTrigger, form);
        addSubmitFormListener(form);
        createModal();
        if (masked) {
            form.addEventListener('reset', () => {
                masked.forEach((elem) => {
                    elem.masked.value = '';
                });
            });
        }
    }
};
